export default __webpack_public_path__ + "static/media/green-checkbox.9a46645b.svg";